import { BarChart3, PackageSearch, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const managementItems = [
  {
    path: '/management/order-analytics',
    label: 'Analizy zamówień',
    icon: PackageSearch,
    description: 'Analiza terminowości zamówień i dostaw materiałów'
  },
  {
    path: '/management/google-reviews',
    label: 'Analiza Google Reviews',
    icon: Star,
    description: 'Analiza opinii klientów z Google'
  },
  {
    path: '/management/tool-analytics',
    label: 'Analizy narzędzi',
    icon: BarChart3,
    description: 'Analiza wykorzystywania narzędzia przez handlowców'
  }
];

const Management = () => {
  const { canAccessGoogleReviews, canAccessOrderAnalytics, canAccessToolAnalytics } = useAuth();
  const visibleItems = managementItems.filter(item => {
    if (item.path === '/management/order-analytics') return canAccessOrderAnalytics();
    if (item.path === '/management/google-reviews') return canAccessGoogleReviews();
    if (item.path === '/management/tool-analytics') return canAccessToolAnalytics();
    return false;
  });

  return (
    <div className="page-container">
      <div className="page-header">
        <h2 className="module-page-title"><BarChart3 aria-hidden="true" /> Zarząd</h2>
        <p>Dashboard i analizy dla zarządu</p>
      </div>
      
      <div className="page-content">
        <div className="tiles-grid">
          {visibleItems.map(item => {
            const Icon = item.icon;
            return <Link key={item.path} to={item.path} className="tile-card module-tile">
              <span className="tile-icon module-tile-icon" aria-hidden="true"><Icon strokeWidth={1.8} /></span>
              <h3 className="tile-title">{item.label}</h3>
              <p className="tile-description">{item.description}</p>
            </Link>;
          })}
        </div>
      </div>
    </div>
  );
};

export { managementItems };
export default Management;
